import React from 'react';
import './features.css';
import ellipse from '../assets/images/Ellipse 10.png';
import arrow1 from '../assets/images/Vector 5.png';
import arrow2 from '../assets/images/Vector 6.png';

const Features = () => {
  return (
    <section className="features-section container">
      <div className="features-left">
        <h2>Features Preview</h2>
        <p>
          Our platform is built to make the RFQ process faster,<br/>
           clearer, and more efficient. From quote collection <br/>
           to vendor communication, every feature is designed <br/>
           to help you save time, reduce costs, and make informed <br/>
           decisions with confidence.
        </p>
        <button className="readmorebtn">Read More</button>
      </div>

      <div className="features-right">
        {/* Background Images */}
        <img src={ellipse} alt="ellipse" className="bg-img ellipse" />
        <img src={arrow1} alt="arrow1" className="bg-img arrow1" />
        <img src={arrow2} alt="arrow2" className="bg-img arrow2" />

        {/* Feature Cards */}
        <div className="feature-box white">Automated Notifications</div>
        <div className="feature-box light-purple">Vendor Management</div>
        <div className="feature-box teal">File Attachments</div>
        <div className="feature-box dark-purple">Quote Comparison Tool</div>
      </div>
    </section>
  );
};

export default Features;
